export default __webpack_public_path__ + "static/media/single-right-blue.8c7ec40c.svg";